/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import styled from 'styled-components';
import React__default, { Children } from 'react';
import { retrieveComponentStyles, DEFAULT_THEME } from '@zendeskgarden/react-theming';

const COMPONENT_ID = 'tags.avatar';
const StyledAvatar = styled(_ref => {
  let {
    children,
    ...props
  } = _ref;
  return React__default.cloneElement(Children.only(children), props);
}).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': '8.76.9'
}).withConfig({
  displayName: "StyledAvatar",
  componentId: "sc-3kdmgt-0"
})(["flex-shrink:0;font-size:0;", ";"], props => retrieveComponentStyles(COMPONENT_ID, props));
StyledAvatar.defaultProps = {
  theme: DEFAULT_THEME
};

export { StyledAvatar };
